var w = Object.defineProperty;
var E = (p, t, e) => t in p ? w(p, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : p[t] = e;
var r = (p, t, e) => (E(p, typeof t != "symbol" ? t + "" : t, e), e);
import { LngLat as R } from "mapbox-gl";
import { fabric as g } from "fabric";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import { calcCalloutScale as G } from "./index.es252.js";
import { isCalloutBox as S, isRoadLabelCalloutBox as L } from "./index.es447.js";
import { CalloutBoxFactory as U } from "./index.es448.js";
import { RoadlabelFactory as q } from "./index.es449.js";
import { TextFactory as H } from "./index.es450.js";
import "./index.es4.js";
import "./index.es20.js";
import "react";
import { getFlattenedLayerConfigArr as F } from "./index.es26.js";
import { getCombinedLayerConfig as V } from "./index.es27.js";
import { getPOICalloutBoxConfig as k } from "./index.es28.js";
import "@tanstack/react-query";
import "qs";
import "./index.es46.js";
import { usePLMapboxStoreV2 as O } from "./index.es6.js";
import { usePLMapboxLayersStore as h } from "./index.es12.js";
import "./index.es99.js";
import "react/jsx-runtime";
import "@placer-ui/components";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "react-map-gl";
import { isEqual as j } from "lodash/fp";
import z from "lodash/throttle";
import K from "lodash/debounce";
import W from "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "@sentry/react";
import "./index.es43.js";
import "lodash";
import "./index.es84.js";
import "./index.es23.js";
import { usePLMapboxFabricStore as x } from "./index.es18.js";
import "./index.es72.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es170.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import { shouldNearbyPOIBeHidden as X } from "./index.es31.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
const v = (p, t) => {
  var e, a;
  return (a = (e = t.maps) == null ? void 0 : e[p]) == null ? void 0 : a.combinedLayerSelection;
}, A = (p, t, e) => {
  var o;
  return !!((o = v(p, t)) != null && o[e]);
}, Y = (p, t, e, a) => {
  var i, s;
  return !!((s = (i = v(p, t)) == null ? void 0 : i[e]) != null && s[a]);
}, N = (p, t, e) => {
  var o;
  const a = (o = v(p, t)) == null ? void 0 : o[e];
  return !!Object.keys(a || {}).length;
}, B = (p, t) => F(t, p).map(
  ({ combinedLayerId: e, visible: a, visualFilter: o }) => ({
    combinedLayerId: e,
    visible: a,
    // We don't need to use the data here, we just need a reference to
    // the object or undefined, to compare oldState vs newState
    // That's why we are not using the useNearbyHiddenPOIs hook or utilities
    hiddenPOIs: o == null ? void 0 : o.hiddenPOIs
  })
), M = (p, t) => {
  var a, o, i;
  return ((i = (o = (a = p.maps) == null ? void 0 : a[t]) == null ? void 0 : o.basemap) == null ? void 0 : i.value) || "hybrid";
}, Q = (p, t) => {
  const e = F(p, t).map(
    ({ combinedLayerId: c, renderType: l, layerGroupId: f, subLayerId: y, data: b, visualFilter: m }) => ({
      combinedLayerId: c,
      layerGroupId: f,
      subLayerId: y,
      renderType: l,
      poiCalloutBoxLogosList: m == null ? void 0 : m.poiCalloutBoxLogosList,
      isGrouped: m == null ? void 0 : m.isGrouped,
      data: b || []
    })
  ), a = e.filter(({ renderType: c }) => c === "nearby").reverse(), o = e.filter(({ renderType: c }) => c === "poi-callout").reverse(), i = e.filter(({ renderType: c }) => c === "chain-venues").reverse(), s = e.filter(({ renderType: c }) => c === "tags").reverse(), n = e.filter(
    ({ renderType: c }) => c === "vtv" || c === "static-vtv"
  ), d = e.filter(({ renderType: c }) => c === "textbox");
  return [
    ...n,
    ...a,
    ...d,
    ...s,
    ...i,
    ...o
  ];
}, D = {
  map: "light",
  hybrid: "dark",
  arcGisImagery: "dark",
  arcGisStreets: "light",
  arcGisTerrain: "light",
  esriHybrid: "dark",
  esriStreets: "light"
};
class oa {
  constructor(t) {
    r(this, "_map");
    r(this, "_container");
    r(this, "_devicePixelRatio");
    r(this, "_basemap");
    r(this, "_dataMap");
    r(this, "_mapId");
    r(this, "_canvasId");
    r(this, "_fabricRef");
    r(this, "_plMapboxStoreListener");
    r(this, "_plMapboxLayersStoreListener");
    r(this, "initialCenterMapPosition", new R(0, 0));
    r(this, "_queue", new W({ results: [], autostart: !0, concurrency: 1 }));
    r(this, "_currentlyHoveredId", "");
    r(this, "tempLabelInfo", {
      id: "",
      pointer: {
        x: 0,
        y: 0
      }
    });
    r(this, "data");
    r(this, "updateData");
    r(this, "fabricCanvas");
    r(this, "updateStyleType");
    r(this, "updateVisible");
    r(this, "redraw");
    r(this, "_updateFabricObjStyle");
    r(this, "updateFabricObjStyle", ({ layerId: t, visible: e }) => {
      var i;
      ((i = this.fabricCanvas) == null ? void 0 : i.getObjects("group")).filter((s) => s.objType === "CalloutBox").forEach((s) => {
        s.set({ visible: e });
      }), this._renderAllFabric();
    });
    r(this, "_updateContainerSize", () => {
      if (this._map && this._container && this.fabricCanvas) {
        const { clientWidth: t, clientHeight: e } = this._map.getContainer(), a = window.devicePixelRatio;
        this.fabricCanvas.setDimensions({
          width: t,
          height: e
        }), a !== this._devicePixelRatio && (g.devicePixelRatio = a, this._devicePixelRatio = a, this.fabricCanvas._initRetinaScaling()), this.fabricCanvas.requestRenderAll();
      }
    });
    r(this, "_handleMouseDownEvt", (t) => {
      var n, d, u, c, l, f, y, b;
      if (!this.fabricCanvas || !this._map)
        return;
      const { clearCombinedLayerSelection: e } = h.getState().actions;
      if (((u = (d = (n = O.getState()) == null ? void 0 : n.maps) == null ? void 0 : d[this._mapId]) == null ? void 0 : u.toolMode) !== "select")
        return;
      this.initialCenterMapPosition = this._map.getCenter();
      const o = this.fabricCanvas.getActiveObject(), i = {
        x: t.point.x,
        y: t.point.y
      }, s = this.fabricCanvas._searchPossibleTargets(
        this.fabricCanvas.getObjects("group"),
        i
      );
      if (!(s != null && s.layerGroupId && ((b = (y = (f = (l = (c = h.getState()) == null ? void 0 : c.maps) == null ? void 0 : l[this._mapId]) == null ? void 0 : f.layerGroupConfig) == null ? void 0 : y[s == null ? void 0 : s.layerGroupId]) == null ? void 0 : b.renderType) === "static-vtv")) {
        if (o && o !== s && S(o) && (o.updateStatus("idle"), o.shouldBeSelected = !1, e({ mapId: this._mapId })), !s) {
          this.fabricCanvas.discardActiveObject();
          return;
        }
        if (s.draggable) {
          this.fabricCanvas.setActiveObject(s).requestRenderAll(), s.calculateOriginMouseDelta(i), s.updateStatus("dragStart"), t.preventDefault();
          return;
        }
        if (s.selectable) {
          if (s.poiInfo.tempLabel) {
            const m = s;
            this.tempLabelInfo = {
              id: m.poiInfo.poiId,
              pointer: i
            };
          }
          this.fabricCanvas.setActiveObject(s).requestRenderAll();
          return;
        }
        this.fabricCanvas.discardActiveObject();
      }
    });
    r(this, "_handleMouseMoveEvt", (t) => {
      if (!this.fabricCanvas || !this._map)
        return;
      const { setHoverPointer: e } = x.getState().actions, a = {
        x: t.point.x,
        y: t.point.y
      }, o = this.fabricCanvas._searchPossibleTargets(
        this.fabricCanvas.getObjects("group"),
        a
      );
      o && L(o) && o.poiInfo.tempLabel ? o.poiInfo.poiId !== this._currentlyHoveredId && (this._currentlyHoveredId = o.poiInfo.poiId, e({ mapId: this._mapId, geoLocation: o.poiInfo.geolocation })) : this._currentlyHoveredId && (this._currentlyHoveredId = "", e({ mapId: this._mapId, geoLocation: void 0 }));
      const i = this.fabricCanvas.getActiveObject();
      i && i.draggable && (i.status === "drag" || i.status === "dragStart") && (i.updatePosition({
        draggedPos: a
      }), i.updateStatus("drag"), this.fabricCanvas.requestRenderAll(), t.preventDefault());
    });
    r(this, "_handleMouseUpEvt", (t) => {
      var d, u, c, l, f;
      if (!this.fabricCanvas)
        return;
      const e = this.fabricCanvas.getActiveObject();
      if (!e || !S(e))
        return;
      const { setCombinedLayerSelection: a, clearCombinedLayerSelection: o, updateLayerGroup: i } = h.getState().actions;
      if (e.isSelectable) {
        if (this._hasDragged()) {
          this.fabricCanvas.discardActiveObject(), this.fabricCanvas.requestRenderAll(), t.preventDefault();
          return;
        }
        if (L(e) && e.poiInfo.tempLabel) {
          const _ = e, I = (l = (c = (u = (d = h.getState().maps) == null ? void 0 : d[this._mapId]) == null ? void 0 : u.layerGroupConfig) == null ? void 0 : c[_.combinedLayerId]) == null ? void 0 : l.visualFilter, C = _.poiInfo.feature, P = {
            type: C.type,
            geometry: {
              type: C.geometry.type,
              // access the coordinates feature so it gets loaded from deck
              coordinates: C.geometry.coordinates
            },
            properties: C.properties
          }, T = {
            ...I == null ? void 0 : I.userAddedFeatures,
            [_.poiInfo.roadId]: P
          };
          i({
            mapId: this._mapId,
            layerGroupId: _.combinedLayerId,
            visualFilter: {
              userAddedFeatures: T,
              tempRoadLabelId: ""
            }
          }), o({ mapId: this._mapId }), e.updateStatus("idle"), this.fabricCanvas.discardActiveObject(), this.fabricCanvas.requestRenderAll();
          return;
        }
        const y = "roadId" in e.poiInfo ? e.poiInfo.roadId : e.poiInfo.poiId, b = (f = this._map) == null ? void 0 : f.getCenter(), m = b == null ? void 0 : b.distanceTo(this.initialCenterMapPosition);
        if (e.isSelectable) {
          const _ = e.status === "drag";
          e.shouldBeSelected = !_ || e.shouldBeSelected;
        }
        (e.status !== "drag" || e.status === "drag" && m === 0) && a({
          mapId: this._mapId,
          layerId: e.layerGroupId,
          features: {
            [y]: e.poiInfo
          }
        }), e.updateStatus(e.shouldBeSelected ? "selectedPOI" : "idle"), this._cacheOffsetPosition(e), this.fabricCanvas.setActiveObject(e).requestRenderAll(), t.preventDefault();
        return;
      }
      const n = A(
        this._mapId,
        h.getState(),
        e.combinedLayerId
      ) ? "select" : "idle";
      this._cacheOffsetPosition(e), e.updateStatus(n), e.resetOriginMouseDelta(), this.fabricCanvas.discardActiveObject(), this.fabricCanvas.requestRenderAll(), t.preventDefault();
    });
    r(this, "_hasDragged", () => this._map ? this._map.getCenter().distanceTo(this.initialCenterMapPosition) > 1 : !1);
    r(this, "_cacheOffsetPosition", (t) => {
      const e = this._mapId, a = t.poiInfo.poiId, o = t.offsetXYFromSource, i = t.layerGroupId, s = t.subLayerId, { updateOffsetGroupMap: n } = h.getState().actions;
      n({
        mapId: e,
        layerGroupId: i,
        subLayerId: s,
        poiId: a,
        position: Object.assign({}, o)
      });
    });
    r(this, "_handlePLMapboxChange", (t, e) => {
      const a = this._mapId, o = M(t, a), i = M(e, a);
      o !== i && this._updateStyleType(o);
    });
    r(this, "_handlePLMapboxLayersChange", (t, e) => {
      const a = this._mapId, o = Q(t, a);
      this._throttledUpdateData(o);
      const i = B(a, t), s = B(a, e);
      j(i, s) || this._updateVisible();
      const n = v(a, t), d = v(a, e);
      j(n, d) || this._updateSelectStatus();
    });
    r(this, "_syncPOICalloutBoxStyle", async ({
      layerId: t,
      poiCalloutBoxConfig: e
    }) => {
      const a = this._dataMap.get(t);
      a && a.forEach(async (o) => {
        const i = Object.keys(e)[0];
        (/* @__PURE__ */ new Set([
          "headerContainerColor",
          "headerContainerOpacity",
          "propertyNameFontColor",
          "propertyAddressFontColor",
          "propertyAddressFontOpacity"
        ])).has(i) ? o.syncCalloutBoxConfig(e) : await this._debouncedUpdateData(this.data);
      });
    });
    r(this, "_syncTextCalloutBoxStyle", async ({
      layerId: t,
      textCalloutBoxConfig: e
    }) => {
      const a = this._dataMap.get(t);
      a && a.forEach(async (o) => {
        const i = Object.keys(e)[0];
        (/* @__PURE__ */ new Set([
          "backgroundContainerColor",
          "backgroundContainerOpacity",
          "textFontColor",
          "textFontOpacity",
          "leaderLineVisible"
        ])).has(i) ? o.syncCalloutBoxConfig(e) : await this._debouncedUpdateData(this.data);
      });
    });
    r(this, "_updateRender", () => {
      if (!this.fabricCanvas)
        return;
      this.fabricCanvas.getObjects("group").filter((a) => a.objType === "CalloutBox").forEach((a) => {
        var n;
        if (!this._map)
          return;
        const o = this._map.getZoom(), i = G(o, (n = a.renderedCalloutBox) == null ? void 0 : n.objType);
        a.scaleX !== i && (a.set({
          scaleX: i,
          scaleY: i
        }), a.setCoords());
        const s = this._map.project(a.poiInfo.geolocation);
        a.updatePosition({
          source: s
        });
      }), this._renderAllFabric();
    });
    r(this, "_updateStyleType", (t) => {
      if (this._basemap = t, !this.fabricCanvas)
        return;
      this.fabricCanvas.getObjects("group").filter((o) => o.objType === "CalloutBox").forEach((o) => {
        this._map && o.updateStyleType(D[t]);
      }), this._renderAllFabric();
    });
    r(this, "_updateVisible", () => {
      if (!this.fabricCanvas)
        return;
      const e = this.fabricCanvas.getObjects("group").filter((o) => o.objType === "CalloutBox"), a = V(
        this._mapId,
        h.getState()
      );
      e.forEach((o) => {
        var s, n, d;
        const i = a[o.combinedLayerId];
        if (i) {
          const u = X(
            i.visualFilter,
            (s = o == null ? void 0 : o.poiInfo) == null ? void 0 : s.poiId
          );
          if (u) {
            const c = (n = this.fabricCanvas) == null ? void 0 : n.getActiveObject();
            if (c && c === o && S(c)) {
              const { clearCombinedLayerSelection: l } = h.getState().actions;
              c.updateStatus("idle"), (d = this.fabricCanvas) == null || d.discardActiveObject(), l({ mapId: this._mapId });
            }
          }
          o.updateVisible(i.visible && !u);
        }
      }), this._renderAllFabric();
    });
    r(this, "_updateSelectStatus", () => {
      if (!this.fabricCanvas)
        return;
      this.fabricCanvas.getObjects("group").filter((a) => a.objType === "CalloutBox").forEach((a) => {
        var n;
        const o = A(
          this._mapId,
          h.getState(),
          a.combinedLayerId
        ), i = N(
          this._mapId,
          h.getState(),
          a.combinedLayerId
        ), s = Y(
          this._mapId,
          h.getState(),
          a.combinedLayerId,
          a.poiInfo.poiId
        );
        a.status === "selectedPOI" ? o || (a.updateStatus("idle"), (n = this.fabricCanvas) == null || n.discardActiveObject()) : i && s || !i && o ? a.updateStatus("select") : a.updateStatus("idle");
      }), this._renderAllFabric();
    });
    r(this, "_throttledUpdateData", z(
      async (t) => this._updateData(t),
      300,
      { leading: !0, trailing: !0 }
    ));
    r(this, "_debouncedUpdateData", K(
      async (t) => this._updateData(t),
      200,
      { leading: !0, trailing: !0 }
    ));
    r(this, "_updateData", (t) => {
      this._queue.splice(0, this._queue.length), this._queue.push(() => this._internalUpdateData(t));
    });
    r(this, "_internalUpdateData", async (t) => {
      if (!this._map || !this.fabricCanvas)
        return;
      const { setFabricLayersStatus: e } = x.getState().actions;
      t.forEach(
        (i) => e({
          mapId: this._mapId,
          layerId: i.combinedLayerId,
          status: "loading"
        })
      ), this.data = t;
      const o = t.map(({ data: i, ...s }) => i.map((n) => ({
        ...s,
        data: n
      })).reverse()).flat().map(async (i) => {
        if (!this.fabricCanvas || !this._map)
          return;
        const s = i.combinedLayerId;
        if (i.renderType === "poi-callout" && i.poiCalloutBoxLogosList && !i.isGrouped && !i.poiCalloutBoxLogosList.includes(i.data.poiId))
          return;
        this._dataMap.get(s) || this._dataMap.set(s, /* @__PURE__ */ new Map());
        const n = this._dataMap.get(s);
        if (n) {
          const d = D[this._basemap];
          if (i.renderType === "vtv" || i.renderType === "static-vtv") {
            const l = await new q({
              layerDataMap: n,
              map: this._map,
              mapId: this._mapId,
              ...i,
              styleType: d
            }).generate();
            if (!l.fromCache) {
              const f = this.fabricCanvas.getActiveObject();
              // Fresh temp label
              (l.calloutBox.poiInfo.tempLabel || // existing selected label with some property changed
              f && L(f) && f.poiInfo.poiId === l.calloutBox.poiInfo.poiId) && (l.calloutBox.updateStatus("select"), this.fabricCanvas.setActiveObject(l.calloutBox).requestRenderAll());
            }
            return l.calloutBox.poiInfo.poiId === this.tempLabelInfo.id && !l.calloutBox.poiInfo.tempLabel && (l.calloutBox.updateStatus("select"), this.fabricCanvas.setActiveObject(l.calloutBox).requestRenderAll(), this.tempLabelInfo.id = ""), l;
          }
          return i.renderType === "textbox" ? new H({
            layerDataMap: n,
            map: this._map,
            mapId: this._mapId,
            styleType: d,
            ...i
          }).generate() : new U({
            layerDataMap: n,
            map: this._map,
            mapId: this._mapId,
            ...i,
            styleType: d
          }).generate();
        }
      });
      Promise.all(o).then((i) => {
        const s = i.length;
        for (let n = 0; n < s; n++) {
          const d = i[n];
          if (d) {
            const { calloutBox: u, fromCache: c } = d;
            this._addCalloutBoxToFabric(u, c);
          }
        }
      }).finally(() => {
        this.cleanDataMapCache(t), this._renderAllFabric(), t.forEach(
          (i) => e({
            mapId: this._mapId,
            layerId: i.combinedLayerId,
            status: "loaded"
          })
        );
      });
    });
    r(this, "_addCalloutBoxToFabric", (t, e) => {
      if (this.fabricCanvas) {
        e || t.getFabricObjects().forEach((o) => {
          var i;
          (i = this.fabricCanvas) == null || i.add(o);
        });
        const a = k({
          mapId: this._mapId,
          state: h.getState(),
          layerGroupId: t.layerGroupId,
          subLayerId: t.subLayerId
        });
        t.syncCalloutBoxConfig(a), t.bringToFront();
      }
    });
    r(this, "_removeCalloutBoxToFabric", (t) => {
      this.fabricCanvas && t.getFabricObjects().forEach((e) => {
        var a;
        (a = this.fabricCanvas) == null || a.remove(e);
      });
    });
    r(this, "syncDataMapWithCanvas", () => {
      this.fabricCanvas && this.fabricCanvas.getObjects("group").filter((a) => a.objType === "CalloutBox").forEach((a) => {
        var n;
        const { combinedLayerId: o, poiInfo: i } = a;
        ((n = this._dataMap.get(o)) == null ? void 0 : n.get(i.poiId)) !== a && this._removeCalloutBoxToFabric(a);
      });
    });
    r(this, "cleanDataMapCache", (t) => {
      const e = new Set(t.map(({ combinedLayerId: a }) => a));
      this._dataMap.forEach((a, o) => {
        if (!e.has(o))
          a.forEach((i, s) => {
            this._removeCalloutBoxToFabric(i), a.delete(s);
          }), this._dataMap.delete(o);
        else {
          const i = t.find(
            ({ combinedLayerId: s }) => s === o
          );
          if (i && (i != null && i.poiCalloutBoxLogosList) && !(i != null && i.isGrouped)) {
            const s = i.poiCalloutBoxLogosList;
            a.forEach((n, d) => {
              s.includes(d) || (this._removeCalloutBoxToFabric(n), a.delete(d));
            });
          }
        }
      }), t.forEach(({ combinedLayerId: a, data: o }) => {
        const i = this._dataMap.get(a);
        if (i) {
          const s = new Set(o.map(({ poiId: n }) => n));
          i.forEach((n, d) => {
            s.has(d) || (this._removeCalloutBoxToFabric(n), i.delete(d));
          });
        }
      }), this.syncDataMapWithCanvas();
    });
    this._mapId = t.mapId, this._fabricRef = t.fabricRef, this._canvasId = `${this._mapId}-fabric-canvas`, this.redraw = t.redraw, this.data = [], this.updateData = this._updateData, this.updateStyleType = this._updateStyleType, this.updateVisible = this._updateVisible, this._devicePixelRatio = window.devicePixelRatio || 1, this._dataMap = /* @__PURE__ */ new Map(), this._updateFabricObjStyle = this.updateFabricObjStyle, this._basemap = M(O.getState(), t.mapId), this._plMapboxStoreListener = O.subscribe(this._handlePLMapboxChange), this._plMapboxLayersStoreListener = h.subscribe(
      this._handlePLMapboxLayersChange
    );
  }
  onAdd(t) {
    this._map = t;
    const e = document.createElement("div");
    Object.assign(e.style, {
      position: "absolute",
      left: 0,
      top: 0
    }), this._container = e;
    const a = document.createElement("canvas");
    a.id = this._canvasId;
    const o = new g.Canvas(a, {
      selection: !1,
      enableRetinaScaling: !0,
      imageSmoothingEnabled: !1,
      renderOnAddRemove: !1
    });
    return this._fabricRef && (this._fabricRef.current = o), g.filterBackend = new g.WebglFilterBackend(), g.initFilterBackend(), this.fabricCanvas = o, e.appendChild(a), Object.assign(a.style, {
      position: "absolute",
      width: "100%",
      height: "100%"
    }), t.on("resize", this._updateContainerSize), t.on("mousedown", this._handleMouseDownEvt), t.on("mousemove", this._handleMouseMoveEvt), t.on("mouseup", this._handleMouseUpEvt), t.on("touchstart", this._handleMouseDownEvt), t.on("touchmove", this._handleMouseMoveEvt), t.on("touchend", this._handleMouseUpEvt), t.on("touchcancel", this._handleMouseUpEvt), t.on("render", this._updateRender), this._updateContainerSize(), x.getState().actions.initMapStore({
      mapId: this._mapId,
      fabricActions: {
        syncPOICalloutBoxStyle: this._syncPOICalloutBoxStyle,
        syncTextCalloutBoxStyle: this._syncTextCalloutBoxStyle
      },
      fabricRef: this._fabricRef
    }), this.redraw(), e;
  }
  /** Called when the control is removed from a map */
  onRemove() {
    const t = this._map;
    t && (t.off("resize", this._updateContainerSize), t.off("render", this._updateRender), t.off("mousedown", this._handleMouseDownEvt), t.off("mousemove", this._handleMouseMoveEvt), t.off("mouseup", this._handleMouseUpEvt), t.off("touchstart", this._handleMouseDownEvt), t.off("touchmove", this._handleMouseMoveEvt), t.off("touchend", this._handleMouseUpEvt), t.off("touchcancel", this._handleMouseUpEvt)), this._plMapboxStoreListener(), this._plMapboxLayersStoreListener(), this._map = void 0, this._container = void 0, this.fabricCanvas = void 0, this._dataMap.clear();
  }
  getDefaultPosition() {
    return "top-left";
  }
  /** Remove from map and releases all resources */
  finalize() {
    this._map && this._map.removeControl(this);
  }
  _renderAllFabric() {
    this.fabricCanvas && this.fabricCanvas.renderAll();
  }
}
export {
  oa as FabricOverlayControl,
  D as basemapStyleMapping,
  Y as isLayerIdFeatureSelected,
  A as isLayerIdSelected,
  N as layerIdHasFeaturesSelected
};
//# sourceMappingURL=index.es399.js.map
